// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notfound_container .bl_page404__wrapper {
  position: relative;
  width: 100%;
  margin: 10px auto 10px;
  max-width: 440px;
  min-height: 410px;
}
.Notfound_container .bl_page404__img {
  width: 100%;
}
.Notfound_container .bl_page404__link {
  display: block;
  margin: 0 auto;
  width: 260px;
  height: 64px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 64px;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
}
.Notfound_container .bl_page404__link:hover,
.Notfound_container .bl_page404__link:focus {
  background-color: #0c3688;
}
.Notfound_container .bl_page404__el1 {
  position: absolute;
  top: 108px;
  left: 102px;
  opacity: 1;
  animation: el1Move 800ms linear infinite;
  width: 84px;
  height: 106px;
  background: url("https://github.com/BlackStar1991/Pictures-for-sharing-/blob/master/404/bigBoom/404-1.png?raw=true") 50% 50% no-repeat;
  z-index: 2;
}
.Notfound_container .bl_page404__el2 {
  position: absolute;
  top: 92px;
  left: 136px;
  opacity: 1;
  animation: el2Move 800ms linear infinite;
  width: 184px;
  height: 106px;
  background: url("https://github.com/BlackStar1991/Pictures-for-sharing-/blob/master/404/bigBoom/404-2.png?raw=true") 50% 50% no-repeat;
  z-index: 2;
}
.Notfound_container .bl_page404__el3 {
  position: absolute;
  top: 108px;
  left: 180px;
  opacity: 1;
  animation: el3Move 800ms linear infinite;
  width: 284px;
  height: 106px;
  background: url("https://github.com/BlackStar1991/Pictures-for-sharing-/blob/master/404/bigBoom/404-3.png?raw=true") 50% 50% no-repeat;
  z-index: 2;
}
@keyframes el1Move {
  0% {
    top: 108px;
    left: 102px;
    opacity: 1;
  }
  100% {
    top: -10px;
    left: 22px;
    opacity: 0;
  }
}
@keyframes el2Move {
  0% {
    top: 92px;
    left: 136px;
    opacity: 1;
  }
  100% {
    top: -10px;
    left: 108px;
    opacity: 0;
  }
}
@keyframes el3Move {
  0% {
    top: 108px;
    left: 180px;
    opacity: 1;
  }
  100% {
    top: 28px;
    left: 276px;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/NotFound/notfound.scss"],"names":[],"mappings":"AACI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AAAN;AAII;EACE,WAAA;AAFN;AAKI;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,mEAAA;EACA,8CAAA;EACA,WAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAHN;AAMI;;EAEE,yBAAA;AAJN;AAOI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,wCAAA;EACA,WAAA;EACA,aAAA;EACA,sIAAA;EACA,UAAA;AALN;AAQI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,wCAAA;EACA,YAAA;EACA,aAAA;EACA,sIAAA;EACA,UAAA;AANN;AASI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,wCAAA;EACA,YAAA;EACA,aAAA;EACA,sIAAA;EACA,UAAA;AAPN;AAUI;EACE;IACE,UAAA;IACA,WAAA;IACA,UAAA;EARN;EAWI;IACE,UAAA;IACA,UAAA;IACA,UAAA;EATN;AACF;AAYI;EACE;IACE,SAAA;IACA,WAAA;IACA,UAAA;EAVN;EAaI;IACE,UAAA;IACA,WAAA;IACA,UAAA;EAXN;AACF;AAcI;EACE;IACE,UAAA;IACA,WAAA;IACA,UAAA;EAZN;EAeI;IACE,SAAA;IACA,WAAA;IACA,UAAA;EAbN;AACF","sourcesContent":[".Notfound_container{\n    .bl_page404__wrapper {\n      position: relative;\n      width: 100%;\n      margin: 10px auto 10px;\n      max-width: 440px;\n      min-height: 410px;\n\n    }\n\n    .bl_page404__img {\n      width: 100%;\n    }\n\n    .bl_page404__link {\n      display: block;\n      margin: 0 auto;\n      width: 260px;\n      height: 64px;\n      background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n      box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n      color: #fff;\n      font-family: \"Open Sans\", sans-serif;\n      font-size: 24px;\n      font-weight: 700;\n      line-height: 64px;\n      text-transform: uppercase;\n      text-decoration: none;\n      border-radius: 30px;\n      text-align: center;\n      cursor: pointer;\n    }\n\n    .bl_page404__link:hover,\n    .bl_page404__link:focus {\n      background-color: #0c3688;\n    }\n\n    .bl_page404__el1 {\n      position: absolute;\n      top: 108px;\n      left: 102px;\n      opacity: 1;\n      animation: el1Move 800ms linear infinite;\n      width: 84px;\n      height: 106px;\n      background: url(\"https://github.com/BlackStar1991/Pictures-for-sharing-/blob/master/404/bigBoom/404-1.png?raw=true\") 50% 50% no-repeat;\n      z-index: 2;\n    }\n\n    .bl_page404__el2 {\n      position: absolute;\n      top: 92px;\n      left: 136px;\n      opacity: 1;\n      animation: el2Move 800ms linear infinite;\n      width: 184px;\n      height: 106px;\n      background: url(\"https://github.com/BlackStar1991/Pictures-for-sharing-/blob/master/404/bigBoom/404-2.png?raw=true\") 50% 50% no-repeat;\n      z-index: 2;\n    }\n\n    .bl_page404__el3 {\n      position: absolute;\n      top: 108px;\n      left: 180px;\n      opacity: 1;\n      animation: el3Move 800ms linear infinite;\n      width: 284px;\n      height: 106px;\n      background: url(\"https://github.com/BlackStar1991/Pictures-for-sharing-/blob/master/404/bigBoom/404-3.png?raw=true\") 50% 50% no-repeat;\n      z-index: 2;\n    }\n\n    @keyframes el1Move {\n      0% {\n        top: 108px;\n        left: 102px;\n        opacity: 1;\n      }\n\n      100% {\n        top: -10px;\n        left: 22px;\n        opacity: 0;\n      }\n    }\n\n    @keyframes el2Move {\n      0% {\n        top: 92px;\n        left: 136px;\n        opacity: 1;\n      }\n\n      100% {\n        top: -10px;\n        left: 108px;\n        opacity: 0;\n      }\n    }\n\n    @keyframes el3Move {\n      0% {\n        top: 108px;\n        left: 180px;\n        opacity: 1;\n      }\n\n      100% {\n        top: 28px;\n        left: 276px;\n        opacity: 0;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
